import Api from "../../../../lib/api";

export default class DataManager {
	constructor() {
		this.url = craft.env.apiSiteUrl + '/feed/proftestData';
		this._data = null;

		this._answers = null;

		this._errorMessage = 'No data fetched!';
	}

	fetch() {
		return Api.get(this.url).then((data) => {
			this._data = data;
		});
	}

	get questions() {
		if (this._data.questions) {
			return this._data.questions;
		}
		throw this._errorMessage;
	}

	get sections() {
		if (this._data.sections) {
			return this._data.sections;
		}
		throw this._errorMessage;
	}

	set answers(answers) {
		this.filterByCoursesAvailability(answers);
	}

	get answers() {
		if (this._answers) {
			return this._answers;
		}
		throw 'There is no answers data!';
	}

	resetAnswers() {
		this._answers = null;
	}

	getSection(id) {
		return this._data.sections.find(item => item.sectionId == id);
	}

	filterByCoursesAvailability(answers) {
		const cityId = Api.currentCityId;
		const sections = this._data.sections;
		const filteredResults = [];
		answers.forEach(a => {
			if (!isNaN(+a.sectionId)) {
				const section = sections.find(s => s.sectionId == a.sectionId);

				const shouldStay = section.courses.some(c => {
					return c.cities[cityId] !== null;
				});

				if (shouldStay) filteredResults.push(a);
			} else {
				filteredResults.push(a);
			}
		});

		this._answers = filteredResults;
	}

	generateHash() {
		let hashedAnswers = '';
		this._answers.forEach(a => {
			const id = isNaN(+a.sectionId) ? a.sectionId[0] : a.sectionId;
			const value = Math.round(+a.rate * 100);
			const chunk = `${id}=${value}`;
			hashedAnswers = hashedAnswers.length ? hashedAnswers + '&' + chunk : hashedAnswers + chunk;
		});
		return 'res?' + hashedAnswers;
	}

	parseHashedAnswers(hash) {
		return hash
			.slice(5) //crop '#res?'
			.split('&')
			.map(v => {
				const valuesPair = v.split('=');
				let sectionId;
				let title;
				switch (valuesPair[0]) {
					case 'g':
						sectionId = 'general';
						break;
					case 'm':
						sectionId = 'motivation';
						break;
					case 's':
						sectionId = 'sincerity';
						break;
					default:
						sectionId = valuesPair[0];
						break;
				}
				const section = this._data.sections.find(s => s.sectionId == sectionId);
				title = section ? section.title : sectionId;

				return {
					sectionId,
					rate: (+valuesPair[1] / 100).toString(),
					section: title
				}
			});
	}
}